<template>
    <div class="performance-table-well-status-dropdown ml-1 mr-5">
        <well-status-dropdown class="left-1 table-well-controls position-absolute" :well="row.item">
            <div class="well-status justify-center align-items-center">
                <img
                    :src="getWellStatusIcons"
                    class="p-2 back-colored"
                    :class="getWellStatusClass"
                    alt=""
                />
            </div>
        </well-status-dropdown>
    </div>
</template>

<script>
import WellStatusDropdown from './partials/WellStatusDropdown'
import UIUtils from '../../business/utils/UIUtils'
import { WELL_STATUS } from '../../business/factory/DataModel'
import { WELL_STATUS_ICONS_PATH } from '../../business/const'

export default {
    name: 'PerformanceTableWellStatusDropdown',
    components: { WellStatusDropdown },
    props: {
        row: {
            type: Object,
            required: true
        }
    },
    computed: {
        getWellStatusIcons() {
            return WELL_STATUS[this.row.item.status]
                ? `${WELL_STATUS_ICONS_PATH}/${this.row.item.status}.svg`
                : `${WELL_STATUS_ICONS_PATH}/DEFAULT.svg`
        },
        getWellStatusClass() {
            const { FROZEN, TRANSFERRED, THAWED, PENDING, DISCARDED } = WELL_STATUS

            const stylesByStatus = {
                [FROZEN]: 'frozen-button',
                [TRANSFERRED]: 'transferred-button',
                [THAWED]: 'thawed-button',
                [PENDING]: 'pending-button',
                [DISCARDED]: 'discard-button'
            }
            return stylesByStatus[this.row.item.status] || 'select-button'
        }
    }
}
</script>

<style lang="scss">
.performance-table-well-status-dropdown {
    position: relative;

    .table-well-controls {
        .dropdown-menu {
            margin-top: -0.8rem;
            min-width: 0;
        }

        .dropdown-item {
            padding: 0.3rem 0;
            width: auto;
        }
    }
}
</style>
